import { FC } from 'react';
import ListCell, { ListCellProps } from './ListCell';

interface Props {
    groups: string[];
    onMoreClick: ListCellProps['onMoreClick'];
}

const GroupCellLayout: FC<Props> = ({ groups, onMoreClick }) => {
    return (
        <ListCell maxChildrenToDisplay={1} onMoreClick={onMoreClick}>
            {groups.map((group, index) => (
                <span key={`${group}_${index}`} className="h-[14px] leading-[14.32px] text-center">
                    {group}
                </span>
            ))}
        </ListCell>
    );
};

export default GroupCellLayout;
